import { gql } from '@apollo/client';

export const CREATE_CARBON_TARGET_MUTATOR = gql`
  mutation CreateCarbonTargetMutation(
    $group_id: String!
    $company_id: String!
    $carbon_target_data: JSON!
    $user_email: String!
  ) {
    createCarbonTarget(
      group_id: $group_id
      company_id: $company_id
      carbon_target_data: $carbon_target_data
      user_email: $user_email
    )
  }
`;

export const UPDATE_CARBON_TARGET_MUTATOR = gql`
  mutation UpdateCarbonTargetMutation(
    $group_id: String!
    $company_id: String!
    $carbon_target_id: String!
    $updated_carbon_target: JSON!
    $original_carbon_target: JSON!
    $user_email: String!
  ) {
    updateCarbonTarget(
      group_id: $group_id
      company_id: $company_id
      carbon_target_id: $carbon_target_id
      updated_carbon_target: $updated_carbon_target
      original_carbon_target: $original_carbon_target
      user_email: $user_email
    )
  }
`;

export const DELETE_CARBON_TARGET_MUTATOR = gql`
  mutation DeleteCarbonTargetMutation(
    $group_id: String!
    $company_id: String!
    $carbon_target_id: String!
    $user_email: String!
  ) {
    deleteCarbonTarget(
      group_id: $group_id
      company_id: $company_id
      carbon_target_id: $carbon_target_id
      user_email: $user_email
    )
  }
`;
